/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ScanPhotoStatus {
}

export enum ScanPhotoStatus_Enum {
  INVALID = 0,
  SUCCESS = 1,
  VEHICLE_STUCK = 2,
  USER_SKIPPED = 3,
  TIMED_OUT = 5,
  UNRECOGNIZED = -1,
}

export function scanPhotoStatus_EnumFromJSON(object: any): ScanPhotoStatus_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return ScanPhotoStatus_Enum.INVALID;
    case 1:
    case "SUCCESS":
      return ScanPhotoStatus_Enum.SUCCESS;
    case 2:
    case "VEHICLE_STUCK":
      return ScanPhotoStatus_Enum.VEHICLE_STUCK;
    case 3:
    case "USER_SKIPPED":
      return ScanPhotoStatus_Enum.USER_SKIPPED;
    case 5:
    case "TIMED_OUT":
      return ScanPhotoStatus_Enum.TIMED_OUT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScanPhotoStatus_Enum.UNRECOGNIZED;
  }
}

export function scanPhotoStatus_EnumToJSON(object: ScanPhotoStatus_Enum): string {
  switch (object) {
    case ScanPhotoStatus_Enum.INVALID:
      return "INVALID";
    case ScanPhotoStatus_Enum.SUCCESS:
      return "SUCCESS";
    case ScanPhotoStatus_Enum.VEHICLE_STUCK:
      return "VEHICLE_STUCK";
    case ScanPhotoStatus_Enum.USER_SKIPPED:
      return "USER_SKIPPED";
    case ScanPhotoStatus_Enum.TIMED_OUT:
      return "TIMED_OUT";
    case ScanPhotoStatus_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseScanPhotoStatus(): ScanPhotoStatus {
  return {};
}

export const ScanPhotoStatus = {
  encode(_: ScanPhotoStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScanPhotoStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanPhotoStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ScanPhotoStatus {
    return {};
  },

  toJSON(_: ScanPhotoStatus): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanPhotoStatus>, I>>(base?: I): ScanPhotoStatus {
    return ScanPhotoStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanPhotoStatus>, I>>(_: I): ScanPhotoStatus {
    const message = createBaseScanPhotoStatus();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
